/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Incident_Time_PlaceholderInputs */

const en_case_field_incident_time_placeholder = /** @type {(inputs: Case_Field_Incident_Time_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const pt_br2_case_field_incident_time_placeholder = /** @type {(inputs: Case_Field_Incident_Time_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconhecida`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Case_Field_Incident_Time_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_incident_time_placeholder = /** @type {((inputs?: Case_Field_Incident_Time_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Incident_Time_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_incident_time_placeholder(inputs)
	return pt_br2_case_field_incident_time_placeholder(inputs)
});